export const updateTrainersWrapperWidth = () => {
    const windowWidth = window.innerWidth;
    const trainersWrapper = document.querySelector('.modal-trainers-inner');

    if (!trainersWrapper) return;

    if (windowWidth >= 1024) {
        let container = trainersWrapper.parentNode;
        let containerWidth = container.width;
        let trainersWidthAdd = (windowWidth - containerWidth) / 2;
        trainersWrapper.style.width = `${containerWidth + trainersWidthAdd}px`;
        return;
    }

    trainersWrapper.style.width = `${windowWidth}px`;
}
const Trainers = () => {
    let selectedStudios = [];

    const querySelectors = {
        trainersThumbs: document.querySelectorAll('.trainers-filter-block [data-trainer-id], .trainers-block [data-trainer-id]'),
        modalTrainers: document.querySelector('.modal-trainers'),
        modalTrainersCloseBtn: document.querySelector('.modal-trainers .name-bar .close'),
        trainersCarousel: document.querySelector('.trainers-container'),
        filterTrainersBtn: document.querySelectorAll('.trainers-filter-block .trainers-filter .pill'),
    }

    const openTrainersModal = (trainerSlideItem) => {
        const trainerId = trainerSlideItem.getAttribute('data-trainer-id');
        console.log('openTrainersModal > ', trainerId)

        if (!window.trainersPopupSwiper) {
            console.error('No slider defined');
            return;
        }

        let index = document.querySelector(`.modal-trainers .swiper-slide[data-trainer-id="${trainerId}"]`).getAttribute('data-swiper-slide-index');

        window.trainersPopupSwiper.slideToLoop(index);

        document.body.style.overflow = 'hidden';
        querySelectors.modalTrainers.classList.add('active');
        updateTrainersWrapperWidth();
    }

    const closeTrainersModal = () => {
        document.body.style.overflow = 'auto';
        // querySelectors.modalTrainers.style.display = 'none';
        querySelectors.modalTrainers.classList.remove('active');
    }

    const handleTrainersModalOpen = (e) => {
        const trainerSlideItem = event.target.closest('.trainer-slide');

        if (trainerSlideItem) {
            openTrainersModal(trainerSlideItem);
        }
    }

    const showAllTrainers = () => {
        querySelectors.filterTrainersBtn.forEach((filterTrainerBtn, index) => {
            if (index === 0) {
                filterTrainerBtn.classList.add('active')
            } else {
                filterTrainerBtn.classList.remove('active')
            }
        })

        querySelectors.trainersThumbs.forEach((trainer) => {
            trainer.style.display = 'block';
        })
    }

    const filterTrainers = (filterTrainerBtn, index) => {
        const studioIndex = filterTrainerBtn.getAttribute('data-studio')
        const isAll = !studioIndex;

        const isActiveButton =  filterTrainerBtn.classList.contains('active');

        filterTrainerBtn.classList.toggle('active')

        if (isAll) {
            showAllTrainers();
            return;
        } else {
            querySelectors.filterTrainersBtn[0].classList.remove('active');
        }

        if (isActiveButton) {
            const indexOfSelectedStudio = selectedStudios.indexOf(studioIndex);

            if (indexOfSelectedStudio >= 0) {
                selectedStudios.splice(indexOfSelectedStudio, 1);
            }
        } else {
            if (studioIndex) {
                selectedStudios.push(studioIndex);
            }
        }

        if (!selectedStudios.length) {
            showAllTrainers();
            return;
        }

        querySelectors.trainersThumbs.forEach((trainer) => {
            const dataStudioIndexes = trainer.getAttribute('data-studios').split(',');
            const trainerIsActive = selectedStudios.some(studioIndex => dataStudioIndexes.includes(studioIndex));

            trainer.style.display = trainerIsActive ? 'block' : 'none';
        })
    }

    const setupListeners = () => {
        if (querySelectors.modalTrainersCloseBtn) {
            querySelectors.modalTrainersCloseBtn.addEventListener('click', closeTrainersModal);
        }

        if (querySelectors.modalTrainersCloseBtn) {
            document.addEventListener('keyup', (e) => {
                if (e.key === 'Escape') {
                    closeTrainersModal();
                }
            });
        }

        if (querySelectors.trainersCarousel) {
            querySelectors.trainersCarousel.addEventListener('click', handleTrainersModalOpen)
        }

        if (querySelectors.filterTrainersBtn.length) {
            querySelectors.filterTrainersBtn.forEach((filterTrainerBtn, index) => {
                filterTrainerBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    filterTrainers(filterTrainerBtn, index);
                });
            })
        }

        window.addEventListener('resize', updateTrainersWrapperWidth);
    }

    return {
        init: () => {
            updateTrainersWrapperWidth();
            setupListeners();

        },
    }
}

export default Trainers().init;
